import React, { useEffect } from "react";
import FooterCopyright from "./footer_copyright";
import { useSelector } from "react-redux";
import { socket } from "../../api/socket.io";
const Footer = () => {
  let role = useSelector((store) => store?.login?.user);
  useEffect(() => {
    socket.on("showSalesTrailPopup", (popEmailList) => {
      console.log(23863861);
      if (popEmailList?.includes(role?.Email)) {
        document.getElementById("complatecalls")?.click();
      }
    });
    return () => {
      socket.off("showSalesTrailPopup"); // Clean up on unmount
    };
  }, [socket]);
  return (
    <div className="mt-4">
      <FooterCopyright />
      <button
        className="btn"
        data-bs-toggle="modal"
        data-bs-target="#modal-call"
        style={{ display: "none" }}
        id="complatecalls"
      >
        Simple modal
      </button>
      <div
        className="modal modal-blur fade"
        id="modal-call"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content shadow-lg border-0 rounded-3">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title text-danger fw-bold">
                ⚠️ Sales Trial App – Action Required
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closemodel"
              ></button>
            </div>

            <div className="modal-body">
              <p className="text-muted mb-3">
                The Sales Trial application is currently not fetching call data.
                Please follow the steps below to fix the issue:
              </p>

              <ol className="list-group list-group-numbered">
                <li className="list-group-item border-0 ps-0">
                  Open the <strong>Sales Trial App</strong>.
                </li>
                <li className="list-group-item border-0 ps-0">
                  Go to <strong>App Settings</strong> → <strong>Storage</strong>{" "}
                  → Tap on{" "}
                  <span className="text-danger fw-bold">Clear App Data</span>.
                </li>
                <li className="list-group-item border-0 ps-0">
                  Re-login into the application.
                </li>
                <li className="list-group-item border-0 ps-0">
                  Refresh the app and check if the calls are fetching properly.
                </li>
              </ol>

              <div className="alert alert-info mt-3">
                If the issue continues, contact Admin Team immediately.
              </div>
            </div>

            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Okay, Got It
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
